export const N77_03 = {
    "columns": 9,
    "rows": 2,
    "visual": {
        "id": 1,
        "type": "advancedTable",
        "colorTheme": 'colorTheme1',
        "title": "Aging Summary",
        "binding": {
            "data": {
                "columns": [
                    {
                        "name": 'Customer Group',
                        "columnName": 'CustomerGroup',
                        "width": '165px',
                        "align": "left",
                        "sortable": true
                    },
                    {
                        "name": 'Not Due',
                        "columnName": 'NotDue',
                        "width": '120px',
                        "align": "right",
                        "sortable": true
                    },
                    {
                        "name": '1 - 30',
                        "columnName": 'OneMonth',
                        "width": '120px',
                        "align": "right",
                        "sortable": true
                    },
                    {
                        "name": '31 - 60',
                        "columnName": 'TwoMonth',
                        "width": '120px',
                        "align": "right",
                        "sortable": true
                    },
                    {
                        "name": '61 - 90',
                        "columnName": 'ThreeMonth',
                        "width": '120px',
                        "align": "right",
                        "sortable": true
                    },
                    {
                        "name": '91 - 120',
                        "columnName": 'FourthMonth',
                        "width": '120px',
                        "align": "right",
                        "sortable": true
                    },
                    {
                        "name": '121 - 150',
                        "columnName": 'FifthMonth',
                        "width": '120px',
                        "align": "right",
                        "sortable": true
                    },
                    {
                        "name": '151 + days',
                        "columnName": 'SixthMonthAbove',
                        "width": '125px',
                        "align": "right",
                        "sortable": true
                    },
                    {
                        "name": 'Current',
                        "columnName": 'Current',
                        "width": '120px',
                        "align": "right",
                        "sortable": true
                    }
                    
                ],
                "title": "CustomerGroup",
                "endpoint": "N77.3",
                "parameters": [
                    { "key": "FromMonth", "value": "2024" },
                    { "key": "FromYear", "value": "1" },
                    { "key": "ToMonth", "value": "2024" },
                    { "key": "ToYear", "value": "1" },
                    { "key": "ConfigTypeCode", "value": "" }
                ]
            },
            "context": {
                "point": {
                    "onClick": {
                    }
                }
            }
        }
    }
}